import { useSelector } from 'react-redux'
import { selectCustomerProfile, selectHomebotNetworkEnabled } from '../../store/selectors/customerProfile'
import {
  selectPreferredLoanOfficerMembership,
  selectPreferredRealEstateAgentMembership
} from '../../store/selectors/clientTeamMemberships'
import { PartnerType } from '../../Components/shared/VerificationFlow'

/**
 * @returns Returns true or false depending on if we should show
 * the preferred agent or lo branding
 */
export const usePreferredAgentBranding = () => {
  const hasHomebotNetworkAccess = useSelector(selectHomebotNetworkEnabled)

  return hasHomebotNetworkAccess
}

const usePreferredAgent = (type?: PartnerType) => {
  const preferredRealEstateAgentMembership = useSelector(selectPreferredRealEstateAgentMembership)
  const preferredLoanOfficerMembership = useSelector(selectPreferredLoanOfficerMembership)

  if (
    type == 'RealEstateAgent' &&
    preferredRealEstateAgentMembership &&
    preferredRealEstateAgentMembership.isVerified
  ) {
    return preferredRealEstateAgentMembership.customerProfile
  } else if (type == 'LoanOfficer' && preferredLoanOfficerMembership && preferredLoanOfficerMembership.isVerified) {
    return preferredLoanOfficerMembership.customerProfile
  }
}

/**
 * Checks if we should show the preferred agent. If so, return the branding object
 * constructed from the preferred agent or the preferred LO.
 *
 * If not, check if we should show the co-sponsor. If so, return the branding
 * object constructed from the co-sponsor.
 *
 * If neither or true, return the branding object from the customer profile.
 *
 * I wrote this while listening to the soundtrack from the movie "Armageddon" and hoping
 * that it attracts a large meteorite to the earth.
 */
export const useCustomerBranding = (type: PartnerType) => {
  const customerProfile = useSelector(selectCustomerProfile)
  const showPreferredAgentBranding = usePreferredAgentBranding()
  const preferredAgent = usePreferredAgent(type)

  if (showPreferredAgentBranding && preferredAgent) {
    return preferredAgent
  }

  return customerProfile
}
